import {
  Badge,
  Box,
  Button,
  Divider,
  Flex,
  Menu,
  MenuButton,
  MenuItemOption,
  MenuList,
  MenuOptionGroup,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { MdAdd } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { toast } from "react-toastify";
import { adminSelectStyles } from "../Models/admin-modal-theme";
import { studentPalette } from "../../constants/studentPalette";
import {
  studentMenuItemOptionSx,
  studentSurfaces,
} from "../../constants/studentThemeSurfaces";
import { createStudentExamsRequest } from "../../modules/students-modules/student-exams/Actions";

const CreateExamMenu = () => {
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.user.userData);
  const chapters = useSelector((state) => state.studentChapters.chapters);

  const [subType, setSubType] = useState("");
  const [chaptersData, setChapters] = useState([]);

  const chaptersOptions = (Array.isArray(chapters) ? chapters : []).map((data) => ({
    value: data.id,
    label: data.name,
  }));

  const appendChapterQuestions = (formData, selected) => {
    selected?.forEach((val, idx) => {
      formData.append(`chapters[${idx}][chapter_id]`, val?.value);
      if (selected.length < 3) {
        formData.append(
          `chapters[${idx}][no_of_questions]`,
          String(30 / selected.length)
        );
      } else {
        formData.append(`chapters[${idx}][no_of_questions]`, "10");
      }
    });
  };

  const createFromChapters = () => {
    if (chaptersData?.length > 3) {
      toast.error("You can select no more than three chapters.");
      return;
    }
    const formData = new FormData();
    formData.append("sub_type", "1");
    appendChapterQuestions(formData, chaptersData);
    dispatch(createStudentExamsRequest(formData));
  };

  const createMiniQuiz = () => {
    const formData = new FormData();
    formData.append("sub_type", "3");
    formData.append(`chapters[0][chapter_id]`, chaptersData?.value);
    formData.append(`chapters[0][no_of_questions]`, "10");
    dispatch(createStudentExamsRequest(formData));
  };

  return (
    <Menu closeOnSelect={false} placement="bottom-start">
      {/*
        Chakra v1: MenuButton without `as={Button}` often drops sizing/fill and renders “invisible”.
        Same pattern as logout-menu.jsx and questions/index.jsx (MenuButton as Button).
      */}
      <MenuButton
        as={Button}
        type="button"
        w="auto"
        px={4}
        py={2}
        minH="40px"
        bg={studentPalette.primary}
        color={studentPalette.cream}
        fontWeight="800"
        fontSize="sm"
        borderRadius="md"
        boxShadow="0 4px 14px rgba(91, 13, 22, 0.35)"
        _hover={{ bg: studentPalette.secondary }}
        _expanded={{ bg: studentPalette.secondary }}
        _active={{ bg: studentPalette.secondary }}
        sx={{
          "html[data-theme='dark'] &": {
            bg: studentPalette.primary,
            color: studentPalette.cream,
            _hover: { bg: studentPalette.secondary },
            _expanded: { bg: studentPalette.secondary },
            _active: { bg: studentPalette.secondary },
          },
        }}
      >
        <Flex as="span" align="center" justify="flex-start" gap={2}>
          <MdAdd size={20} />
          <span>Create Exam</span>
        </Flex>
      </MenuButton>
      <MenuList
        minWidth="260px"
        bg={studentSurfaces.raised}
        borderColor={studentSurfaces.border}
        color="var(--text-primary)"
        zIndex={2000}
        sx={{
          "html[data-theme='dark'] &": {
            bg: "var(--surface-raised)",
            borderColor: "var(--border-subtle)",
          },
        }}
      >
        <MenuOptionGroup type="radio" defaultValue="">
          <MenuItemOption
            value="2"
            sx={studentMenuItemOptionSx}
            onClick={() => {
              setSubType(2);
              const formData = new FormData();
              formData.append("sub_type", "2");
              dispatch(createStudentExamsRequest(formData));
            }}
          >
            Comprehensive
          </MenuItemOption>
          <MenuItemOption
            value="1"
            sx={studentMenuItemOptionSx}
            onClick={() => setSubType(1)}
          >
            From chapters
          </MenuItemOption>
          <MenuItemOption
            value="3"
            sx={studentMenuItemOptionSx}
            onClick={() => setSubType(3)}
          >
            Mini quiz
          </MenuItemOption>
        </MenuOptionGroup>
        {userData?.grade?.id === 10 && (
          <MenuItemOption
            value="4"
            sx={studentMenuItemOptionSx}
            onClick={() => {
              dispatch(
                createStudentExamsRequest({
                  name:
                    "Personalized Exam " +
                    new Date().toLocaleDateString("en-GB"),
                  type: 9,
                  sub_type: 9,
                  chapters: [],
                  timer: 0,
                  time: 0,
                  question_number: 30,
                  published: 1,
                })
              );
            }}
          >
            Personalized Exam{" "}
            <Badge colorScheme="yellow" ml={2}>
              Premium
            </Badge>
          </MenuItemOption>
        )}
        {subType === 1 && (
          <>
            <Divider borderColor={studentSurfaces.border} />
            <Box p={4}>
              <Select
                options={chaptersOptions}
                isMulti
                onChange={(data) => setChapters(data || [])}
                styles={adminSelectStyles()}
                placeholder="Select lecture"
              />
              <Button
                mt={3}
                w="full"
                bg={studentPalette.primary}
                color={studentPalette.cream}
                fontWeight="700"
                onClick={createFromChapters}
              >
                Create
              </Button>
            </Box>
          </>
        )}
        {subType === 3 && (
          <>
            <Divider borderColor={studentSurfaces.border} />
            <Box p={4}>
              <Select
                options={chaptersOptions}
                onChange={(data) => setChapters(data)}
                styles={adminSelectStyles()}
                placeholder="Select chapter"
              />
              <Button
                mt={3}
                w="full"
                bg={studentPalette.primary}
                color={studentPalette.cream}
                fontWeight="700"
                onClick={createMiniQuiz}
              >
                Create
              </Button>
            </Box>
          </>
        )}
      </MenuList>
    </Menu>
  );
};

export default CreateExamMenu;
